export default __webpack_public_path__ + "static/media/home.c8059be2.png";